import { Query } from "src/types/Request";
import { formatDate } from "src/utils/formatDate";

export const defaultQuery: Query = {
    gte: formatDate(new Date()),
    per_page: 4,
}